import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CategoryHero, Grid, GridItem } from '@which/seatbelt'

import { useFeatureValue } from '@growthbook/growthbook-react'

import type { PageParams } from '../../../../../routes'
import { singleBrandUrlRegex } from '../../../../../shared/constants/single-brand-ulr-regex'
import { useFullUrl } from '../../../../../shared/hooks/useFullUrl'
import { useMatchMedia } from '../../../../../shared/hooks/useMatchMedia'
import { useAppliedFilters } from '../../hooks/useAppliedFilters'
import styles from '../../ProductListingPage.module.scss'
import { ReviewsTemplateContext } from '../../ReviewsTemplateContext'
import { getCategoryInfo } from '../../utils/get-category-info'
import { TopBanner } from '../TopBanner'
import type { BannerConfig } from '../TopBanner/TopBanner'

export const ReviewsProductListingHeader: FunctionComponent = () => {
  const { state } = useContext(ReviewsTemplateContext)
  const { header, filters, needsBasedFilters, meta } = state.productListingPageData
  const { getFullUrl } = useFullUrl()
  const [, maybeBrandName] = getFullUrl().match(singleBrandUrlRegex) || []
  const { appliedFilters } = useAppliedFilters(filters, needsBasedFilters)
  const { name: categoryName } = meta.taxonomyHierarchy.category
  const { categorySlug } = useParams<PageParams>()
  const bannerConfig = useFeatureValue<BannerConfig>('WHC-BF24-Banner', null)
  const { heading, description } = getCategoryInfo({
    heading: header.heading,
    description: header.description,
    metaDesc: meta?.desc,
    categoryName,
    appliedFilters,
    brandName: maybeBrandName,
  })
  const isTabletOrAbove = useMatchMedia('(min-width: 768px)')

  return (
    <>
      <div className={styles.reviewsCategoryHeroBleed}>
        <div className="w-page-wrapper">
          <Grid includeGutters={false} className={styles.reviewsCategoryHeroGrid}>
            <GridItem columnStart={{ medium: 1, large: 1 }} span={{ medium: 12, large: 12 }}>
              <CategoryHero
                {...header}
                heading={heading}
                description={description}
                className={styles.reviewsCategoryHero}
                data-testid="category-header"
                headingTag="h1"
                image={isTabletOrAbove ? header.image : undefined}
              />
            </GridItem>
          </Grid>
        </div>
      </div>
      <TopBanner bannerConfig={bannerConfig} categorySlug={categorySlug} />
    </>
  )
}
